const doc = [({"ko":({"adminConstantListTypes":({"planList":"계획 목록으로 보기", "roomList":"객실 목록으로 보기"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;